export const ALL_MARKETS = ["Delhi NCR"];

export const ALL_TOUCHPOINTS = [
  "Premium High Street",
  "Golf Course",
  "Neighborhood Premium Mall",
  "Neighborhood Hi-Street",
  "Feeder Route",
  "Arterial Route",
  "CBD-SOHO",
  "Luxury Residential",
];

export const ALL_COHORTS = [
  "Working Professionals-A",
  "Working Professionals-B",
  "Entrepreneurs",
  "HNI (18 yrs - 60 yrs)",
  "Gen-Zs",
  "Gig Workers",
  "College Students (25 yrs - 50 yrs)",
  "Young Adults (18 yrs - 25 yrs)",
  "Diners",
  "Affluent Shoppers",
];

export const ALL_MARKET_SITES = {
  "Premium High Street": [
      "Cybercity Gurgaon",
      "GK2 Greater Kailash South Delhi",
      "CP Outer Circle Delhi",
      "CP Inner Circle Delhi",
      "CyberHub Gurgaon",
      "GK1 Greater Kailash South Delhi",
      "CP Mid Circle Delhi",
      "IFC M3M Gurgaon",
      "Sector 29 Gurgaon"
  ],
  "Golf Course": [
      "Delhi Golf Course Delhi",
      "ITC Golf Course Gurgaon",
      "Jaypee Greens Golf Course Greater Noida",
      "Noida Golf Course Sector 37"
  ],
  "Neighborhood Premium Mall": [
      "South Point Mall Gurgaon",
  ],
  "Neighborhood Hi-Street": [
      "Nehru Palace South Delhi",
      "JwalaHeri West Delhi"
  ],
  "Feeder Route": [
      "Udyog Bhawan Delhi",
      "RK Ashram Delhi",
      "San Martin Marg Delhi",
      "Khan Market Delhi",
      "Chanakyapuri Delhi",
      "AIIMS Delhi",
      "Lodhi Estate Delhi",
      "INA Delhi",
      "South Avenue Delhi",
      "Panchkuian Road Delhi",
      "Saket South Delhi",
      "KG Marg Delhi",
      "Kali Bari Delhi",
      "Emporio South Delhi"
  ],
  "Arterial Route": [
      "Gol Dakkhana Delhi",
      "Patel Chowk Delhi",
      "Safdarjung Delhi"
  ],
  "CBD-SOHO": [
      "Jasola South Delhi",
      "Signature Tower Gurgaon",
      "Signature Tower Google Building Gurgaon",
      "Global Business Park Gurgaon"
  ],
  "Luxury Residential": [
      "Shanti Niketan South Delhi"
  ]
}

export const ALL_INDUSTRY = [
    "Advertising",
    "Marketing",
    "Creative Design",
    "Real Estate",
    "Agriculture and Allied Industries",
    "Textile and Apparel Industry",
    "Automobile and Auto Components",
    "Steel and Heavy Industries",
    "Cement Industry",
    "Oil, Gas, and Petroleum Industry",
    "Power and Electricity Sector",
    "Pharmaceuticals and Biotechnology",
    "Healthcare and Medical Devices",
    "Information Technology (IT) and ITES",
    "Telecommunications",
    "Banking and Financial Services (BFSI)",
    "Insurance Sector",
    "FinTech Industry",
    "E-commerce and Retail",
    "Real Estate and Construction",
    "Education and EdTech",
    "Media and Entertainment",
    "Tourism and Hospitality",
    "Transport and Logistics",
    "Aviation and Aerospace",
    "Defence and Military Manufacturing",
    "Renewable Energy (Solar, Wind, Hydro)",
    "Startups and Venture Capital",
    "Electronics and Semiconductors",
    "Gems and Jewellery",
    "Leather and Footwear",
    "Handicrafts and Handlooms",
    "Food Processing Industry",
    "Chemical and Fertilizer Industry",
    "Maritime and Shipping",
    "Space Technology",
    "Environmental and Sustainability Industry",
    "Coir and Jute Industry",
    "Paper and Packaging Industry",
    "Wood and Furniture Industry",
    "Mining and Minerals",
    "Cybersecurity and Data Services",
    "Legal and Compliance Services",
    "Consulting and Business Services"
];

export const ALL_WHO_AM_I = [
    "Chief Marketing Officer (CMO)",
    "VP of Marketing",
    "Digital Marketing Manager",
    "Performance Marketing Lead",
    "Media Buyer / Media Planner",
    "Programmatic Advertising Manager",
    "Brand Manager",
    "Marketing Analyst",
    "Campaign Manager",
    "Growth Marketing Manager",
    "Customer Insights Manager",
    "Sales & Revenue Roles",
    "Chief Revenue Officer (CRO)",
    "Sales Director",
    "Business Development Manager",
    "Key Account Manager",
    "Client Success Manager",
    "Revenue Operations Manager",
    "Data & Technology Roles",
    "Chief Data Officer (CDO)",
    "Data Analyst / Data Scientist",
    "Business Intelligence Analyst",
    "Data Engineer",
    "CRM Manager",
    "Data Operations Manager",
    "Martech Specialist",
    "Product Manager (AdTech/MarTech tools)",
    "Analytics Manager",
    "Real Estate / Property Management Roles",
    "Chief Operating Officer (COO)",
    "Head of Property Management",
    "Leasing Manager",
    "Property Manager",
    "Asset Manager",
    "Facility Manager",
    "Portfolio Manager",
    "Agencies / Media Partner Roles",
    "Account Director",
    "Account Manager",
    "Agency Planner",
    "Media Strategy Lead",
    "Ad Operations Manager",
    "Programmatic Specialist"
];